// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  guildId: __t.u64().primaryKey().name("guild_id"),
  masterTermEnds: __t.timestamp().name("master_term_ends"),
  councilTermEnds: __t.timestamp().name("council_term_ends"),
  seats: __t.u32(),
  policy: __t.string(),
  updatedAt: __t.timestamp().name("updated_at"),
});
